<template><div class="help-about">
  <b>TMV Remote Diagnostics Portal</b> &mdash; Release Notes
  <loading v-if="fetching" />
  <div class="notes" v-html="notes" v-if="notes" />
  <p class="error" v-if="error">
    An error occurred when fetching the release notes.
    <button v-if="!fetching" @click="fetch">Try again</button>
  </p>
</div></template>
<script>
import Loading from '../Loading'
import marked from 'marked'
const notesUrl = '/s/sw_changes.md'
export default {
  name: 'help-about',
  components: { Loading },
  data() {
    return {
      notes: null,
      fetching: false,
      error: null,
    }
  },
  methods: {
    async fetch() {
      this.notes = null
      this.fetching = true
      this.error = null
      fetch(notesUrl).then(r => r.text()).then(notes => {
        console.log('fetched:', notes.body)
        this.notes = marked(notes)
      }).catch((err) => {
        console.error('error:', err)
        this.error = true
      }).finally(() => {
        this.fetching = false
      })
    },
  },
  created() { this.fetch() },
  activated() { this.fetch() },
}
</script>
<style lang="scss">
  .help-about {
    ol { counter-reset: list; }
    ol > li { list-style: none; position: relative; }
    ol > li:before { content: counter(list, decimal) ") "; counter-increment: list; position: absolute; left: -1.3em; }
    ol ol > li:before { content: counter(list, lower-alpha) ") "; }

  }
</style>
